module.exports = __webpack_public_path__ + "img/logo2.c6845c34.png";